import moment from 'moment'

import useField from '../Field/useField'

const Preview = (): string => {
  const startDate = useField('startDate')
  const endDate = useField('endDate')

  return `${moment(startDate).format('DD.MM.YYYY HH:mm')} - ${moment(
    endDate,
  ).format('DD.MM.YYYY HH:mm')}`
}

export default Preview
